import type { SelfOwnedWidgetViewModel } from 'src/store/types';

// Transport code must classify payloads without importing model constructors:
// models themselves depend on workspace queries. The registry must implement
// every key here, and the Redux marker union must describe the same set.
const selfOwnedWidgetTypes = {
    'alpha-eye': true,
    events: true,
    filings: true,
    news: true,
    notepad: true,
    platforms: true,
    results: true,
    symbols: true,
    table: true,
    traders: true,
    'tradingview-chart': true,
} satisfies Record<SelfOwnedWidgetViewModel['type'], true>;

export type SelfOwnedWidgetType = keyof typeof selfOwnedWidgetTypes;

export function isSelfOwnedWidgetType(type: string): type is SelfOwnedWidgetType {
    return Object.hasOwn(selfOwnedWidgetTypes, type);
}
